export enum StatoClasseAttivabile {
  programmato = 'PROGRAMMATO',
  daSostenere = 'DA_SOSTENERE',
  nonReferente = 'NON_REFERENTE'
}
